import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './Dialog';

/**
 * Reusable modal using Animate UI–style Dialog (Radix + Motion).
 * Same API as before: isOpen, onClose, title, icon, children, disableClose.
 * Optional contentClassName (e.g. max-w-lg) for the content box.
 * Optional bodyClassName for the area below the header (default horizontal + bottom padding).
 */
export function Modal({
  isOpen,
  onClose,
  title,
  icon,
  children,
  disableClose = false,
  contentClassName,
  bodyClassName = 'px-6 pb-6 pt-5',
}: any) {
  const handleOpenChange = (open) => {
    if (!open && !disableClose) onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent
        open={isOpen}
        showCloseButton={!disableClose}
        contentClassName={contentClassName}
        aria-describedby={undefined}
        onEscapeKeyDown={(e) => disableClose && e.preventDefault()}
        onPointerDownOutside={(e) => disableClose && e.preventDefault()}
      >
        <DialogHeader className="shrink-0">
          <DialogTitle asChild>
            <h2 className="text-xl font-semibold text-slate-100 flex items-center pr-10">
              {icon && <span className="mr-2 flex-shrink-0">{icon}</span>}
              {title}
            </h2>
          </DialogTitle>
        </DialogHeader>
        <div className={`min-h-0 flex-1 flex flex-col ${bodyClassName}`}>{children}</div>
      </DialogContent>
    </Dialog>
  );
}

export default Modal;
